import React from 'react';
import { globalHistory } from '@reach/router';
import { FormattedSimpleMsg, getProjectOptions } from 'GlobalFunctions';
import qs from 'qs';

export const WindowLocation = globalHistory.location;

//موجودیت ها
export const entityList = [
  'email',
  'hashtag',
  'ip',
  'mention',
  'mobile',
  'national_code',
  'phone',
  'postal_code',
  'url',
];

export const elasticVersionApiPaths = [
  'news',
  '/telegram/posts',
  '/telegram/posts/',
  '/telegram/info',
  '/telegram/subjects',
  '/telegram/subjects/',
  '/telegram/posts/publish_process',
  '/telegram/posts/post_process',
  '/telegram/batch/publish/process',
  '/telegram/posts/category/chart',
  '/telegram/channels',
  '/telegram/channels/',
  '/telegram/channels/by_subject',
  '/telegram/channels/count_by_members',
  '/telegram/channels/cloud',
  '/telegram/channels/views',
  '/telegram/channels/political_direction/chart',
  '/telegram/info/process',
  '/telegram/posts/sentiment',
  '/telegram/channels/info',
  '/telegram/channels/most_viewed',
  '/telegram/comments',
  '/twitter/posts',
  '/twitter/info',
  '/twitter/subjects',
  '/twitter/posts/tweet_process',
  '/twitter/posts/gender',
  '/twitter/posts/sentiment',
  '/twitter/posts/age_classification',
  '/twitter/posts/category/chart',
  '/twitter/batch/publish/process',
  '/twitter/users',
  '/twitter/users/by_subject',
  '/twitter/users/{id}/history',
  '/twitter/users/{id}/avatar_history',
  '/instagram/posts',
  '/instagram/info',
  '/instagram/posts/share_process',
  '/instagram/batch/publish/process',
  '/instagram/subjects',
  '/instagram/users',
  '/instagram/users/by_subject',
  '/instagram/posts/gender',
  '/instagram/posts/age_classification',
  '/instagram/posts/category/chart',
  '/instagram/users/{id}/history',
  '/instagram/users/{id}/avatar_history',
  '/instagram/comments',
];

export const APIPaths = {
  telegramgroupsposts: '/telegram/groups/posts',
  telegramposts: '/telegram/posts', //-----
  telegramcomments: '/telegram/comments',
  telegramchannels: '/telegram/channels', // NEEDS ID,
  telegramchannelsbysubject: '/telegram/channels/by_subject', // NEEDS ID,
  telegramusers: '/telegram/users',
  telegramgroups: '/telegram/groups',
  facebookposts: '/facebook/posts', //----
  facebookpostscomments: '/facebook/posts/comments',
  facebookusers: '/facebook/users',
  facebookusersbysubject: '/facebook/users/by_subject',
  facebookpages: '/facebook/pages',
  facebookpagesbysubject: '/facebook/pages/by_subject',
  instagramposts: '/instagram/posts', //----
  instagramcomments: '/instagram/comments',
  instagramusers: '/instagram/users', // NEEDS ID,
  instagramusersbysubject: '/instagram/users/by_subject',
  twitterposts: '/twitter/posts', //----
  twitterusers: '/twitter/users', // NEEDS ID,
  twitterusersbysubject: '/twitter/users/by_subject', // NEEDS ID,
  dumperposts: '/dumper/posts', //---
  wikileaksposts: '/wikileaks/posts', //---
  whoisfields: '/whois/fields', //not exist now
  advertisementposts: '/advertisement/posts', //---
  dunroposts: '/dunro/posts', //---
  blogposts: '/blog/posts', //---
  ketabavvalposts: '/ketabavval/posts', //----
  rrkposts: '/rrk/posts', //---
  search_engineposts: '/search_engine/posts', //---
  newsposts: '/news/posts', //---
  newsagencies: '/news/agencies', //---
  newsagenciesbysubject: '/news/agencies/by_subject', //---

  apiparams: '/api/wh/apiParams',
  deletepreset: '/api/preset/delete',
  addpreset: '/api/preset/add',
  loadingplatformdata: '/api/wh/call', //برای دریافت اطلاعات از هر بستر
  selectpreset: '/api/preset/list',

  excelAdd: '/search/excels',
  excelList: '/search/excels',
  excelCancel: '/search/excels/cancel',
  excelRestart: '/search/excels/restart',
  excelDownload: '/search/excel/download/',
  // مسیر ای پی آی ها برای تست موقت تغییر کرده است
  excelAdd_v1: '/search/api/v1/excels',
  excelList_v1: '/search/api/v1/excels',
  excelCancel_v1: '/search/api/v1/excels/cancel',
  excelRestart_v1: '/search/api/v1/excels/restart',
  excelDownload_v1: '/search/api/v1/excels/download',

  searchMapping: '/search/api/v1/mapping',
  searchPlatforms: '/search/v2/platforms',
  boxGenerator: '/dashboard/box',
  searchAPI: '/search',
  queryRules: '/search/queries',
  queryPlatforms: '/search/queries/platforms',
  queryFiles: '/search/query_files',
  tags: '/search/tags',

  googleplususers: '/googleplus/users',
  googleplusposts: '/googleplus/posts',
  linkedinprofiles: '/linkedin/profiles',
  whoisposts: '/whois/posts',

  newspaperagencies: '/newspaper/agencies',
  newspaperposts: '/newspaper/posts',

  expert_opinions: '/expert_opinions',

  twitterUsersSatisfactionIndicator: '/twitter/users/satisfaction_indicator',
  instagramUsersCommentsSatisfactionIndicator:
    '/instagram/users/comments_satisfaction_indicator',
  instagramUsersPostsSatisfactionIndicator:
    '/instagram/users/posts_satisfaction_indicator',

  //'dashboard': '/dashboard',
};

export const searchApiPaths = [
  // telegram
  '/telegram/posts',
  '/telegram/channels',
  '/telegram/comments',
  '/telegram/channels/by_subject',
  '/telegram/users',
  '/telegram/groups',
  '/telegram/groups/posts',

  // twitter
  '/twitter/posts',
  '/twitter/users',
  '/twitter/users/by_subject',

  // instagram
  '/instagram/posts',
  '/instagram/comments',
  '/instagram/users',
  '/instagram/users/by_subject',

  // facebook
  '/facebook/posts',
  '/facebook/posts/comments',
  '/facebook/users',
  '/facebook/users/by_subject',
  '/facebook/pages',
  '/facebook/pages/by_subject',

  // news
  '/news/posts',
  '/news/agencies',
  '/news/agencies/by_subject',

  // newspaper
  '/newspaper/posts',
  '/newspaper/agencies',

  // Google Plus
  '/googleplus/posts',
  '/googleplus/users',

  // others
  '/linkedin/profiles',
  '/blog/posts',
  '/ketabavval/posts',
  '/rrk/posts',
  '/search_engine/posts',
  '/dumper/posts',
  '/dunro/posts',
  '/wikileaks/posts',
  '/whois/posts',
  '/advertisement/posts',

  '/expert_opinions',
];

//آدرس ای پی آی روت
const option = getProjectOptions();

export const root = option.apiBase;
export const rootIoSocket = option.apiSocket;
export const rootSocketPath = option.pathSocket;

export const imagesStaticUrl =
  'https://f002.backblazeb2.com/file/all-gather-media/';

//مپ کردن فیلدهای ای پی آی به نحوه نمایش
export const mapParamToView = {
  sort: 'select',
  sort_type: 'select',
  sentiment: 'select',
  lang: 'lang',
  min_view: 'slider',
  max_view: 'slider',
  min_advert_noise: 'slider',
  max_advert_noise: 'slider',

  sentiment_negative_min: 'slider',
  sentiment_negative_max: 'slider',
  sentiment_neutral_min: 'slider',
  sentiment_neutral_max: 'slider',
  sentiment_positive_min: 'slider',
  sentiment_positive_max: 'slider',

  is_bot: 'checkbox',
  expires: 'datepicker',
  gender: 'radio',
  hometown: 'inputtext',
  partner: 'inputtext',
  // source: "radio",
  zone: 'inputtext',
  source: 'radio',
  // media_type: "select",
  exists: 'multiselect',
  relation_ages_cls: 'multiselect',
  ages_cls: 'multiselect',
  q: 'query',
  resource_ids: 'resource',
  post_resource_ids: 'post_resource',
  ids: 'resource',
  count: 'count',
  media_type: 'multiselect',
  search_engines: 'checklist',
  nationalities: 'multiselect',
  samane_is_assigned: 'boolian',
  samane_is_replied: 'boolian',
  samane_is_deleted: 'boolian',
  has_content_tag: 'boolian',
  location: 'query_string',
  has_location: 'boolian',
  seen: 'boolian',
  categories: 'array',
  check_history: 'checkbox',
};

export const icons = {
  // اینستاگرام
  instagramposts: 'icon-instagram-post',
  instagram: 'icon-instagram',
  instagramcomments: 'icon-instagram',
  instagramusers: 'icon-instagram-users',
  instagramusersbysubject: 'icon-instagram-users',

  //توییتر
  twitterposts: ' icon-twitter-post',
  twitter: 'icon-twitter',
  twitterusers: ' icon-twitter-users',
  twitterusersbysubject: ' icon-twitter-users',

  //تلگرام
  telegramposts: 'icon-telegram-post',
  telegram: 'icon-telegram',
  telegramcomments: 'icon-telegram',
  telegramgroups: 'icon-telegram-group',
  telegramgroupsposts: 'icon-telegram-group-post',
  telegramchannels: 'icon-telegram-channel',
  telegramchannelsbysubject: 'icon-telegram-channel',
  telegramchannel: 'icon-telegram-channel',
  telegramusers: 'icon-telegram-users',
  telegramuser: 'icon-telegram-users',

  //خبر
  news: 'icon-newspaper',
  newsagencies: 'icon-news-agency',
  newsagenciesbysubject: 'icon-news-agency',
  newsposts: 'icon-news-post',

  // روزنامه
  newspaperposts: 'icon-newspaper',
  newspaperagencies: 'icon-newspaper',

  //فیس بوک
  facebookposts: 'icon-facebook-post',
  facebookusers: 'icon-facebook-users',
  facebookusersbysubject: 'icon-facebook-users',
  facebookpages: 'icon-facebook-group',
  facebookpagesbysubject: 'icon-facebook-group',
  facebookpostscomments: 'icon-facebook-post',

  mobile: 'icon-mobile',
  email: 'icon-email',

  dumperposts: 'icon-dumper-post',

  wikileaksposts: 'icon-wikileaks',

  advertisementposts: 'icon-advertisment',

  dunroposts: 'icon-dunro-post',

  blogposts: 'icon-blog-post',

  ketabavvalposts: 'icon-ketab-aval-post',

  rrkposts: 'icon-oficial-news-post',

  // گوگل پلاس
  googleplususers: 'icon-google-plus-user',
  googleplusposts: 'icon-google-plus-post',

  linkedinprofiles: 'icon-linkedin-user',

  whoisposts: 'icon-whois',

  // موتورهای جستجو
  search_engineposts: 'icon-search-result',
  searchengineposts: 'icon-search-result',

  expertopinions: 'icon-newspaper',
};

export const language = {
  languageId: 'persian',
  locale: 'fa',
  text: 'Persian',
  icon: '',
};

export const boxGeneratorComponentProps = {
  box: [
    {
      value: 'avatar',
      type: 'string',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.box.avatar' />
      ),
    },
    {
      value: 'bio',
      type: 'string',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.box.bio' />
      ),
    },
    {
      value: 'description',
      type: 'string',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.box.description' />
      ),
    },
    {
      value: 'full_name',
      type: 'string',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.box.full_name' />
      ),
    },

    {
      value: 'username',
      type: 'string',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.box.username' />
      ),
    },
    {
      value: 'id',
      type: 'string',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.box.id' />
      ),
    },
    {
      value: 'image',
      type: 'string',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.box.image' />
      ),
    },
    {
      value: 'about',
      type: 'string',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.box.about' />
      ),
    },
    {
      value: 'follower_count',
      type: 'int',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.box.follower_count' />
      ),
    },
    {
      value: 'following_count',
      type: 'int',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.box.following_count' />
      ),
    },
    {
      value: 'member_count',
      type: 'int',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.box.member_count' />
      ),
    },
    {
      value: 'comment_count',
      type: 'int',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.box.comment_count' />
      ),
    },
    {
      value: 'post_count',
      type: 'int',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.box.post_count' />
      ),
    },
    {
      value: 'tweets',
      type: 'int',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.box.tweets' />
      ),
    },
    {
      value: 'retweets',
      type: 'int',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.box.retweets' />
      ),
    },
    {
      value: 'like_count',
      type: 'int',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.box.like_count' />
      ),
    },
    {
      value: 'view_count',
      type: 'int',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.box.view_count' />
      ),
    },
    {
      value: 'media_count',
      type: 'int',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.box.media_count' />
      ),
    },
    {
      value: 'relationid',
      type: 'string',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.box.relationid' />
      ),
    },
    {
      value: 'relationinfluence',
      type: 'string',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.box.relationinfluence' />
      ),
    },
    {
      value: 'newsinfluence',
      type: 'string',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.box.newsinfluence' />
      ),
    },
    {
      value: 'influence',
      type: 'string',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.box.influence' />
      ),
    },
    {
      value: 'is_private',
      type: 'boolean',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.box.is_private' />
      ),
    },
    {
      value: 'is_verified',
      type: 'boolean',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.box.is_verified' />
      ),
    },
    {
      value: 'language',
      type: 'string',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.box.language' />
      ),
    },
    {
      value: 'media_type',
      type: 'string',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.box.media_type' />
      ),
    },
    {
      value: 'robot',
      type: 'datetime',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.box.robot' />
      ),
    },
    {
      value: 'alexa_rank',
      type: 'int',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.box.alexa_rank' />
      ),
    },
    {
      value: 'ir_rank',
      type: 'int',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.box.ir_rank' />
      ),
    },
    {
      value: 'url',
      type: 'string',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.box.url' />
      ),
    },
    {
      value: 'relationUrl',
      type: 'string',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.box.relationUrl' />
      ),
    },
    {
      value: 'time',
      type: 'datetime',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.box.time' />
      ),
    },
    {
      value: 'hashtags',
      type: 'string',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.box.hashtags' />
      ),
    },
  ],
  largeScaleAreaMap: [
    {
      value: 'flow',
      type: 'int',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.largeScaleAreaMap.flow' />
      ),
    },
    /*{
			value: 'rain',
			type: 'int',
			description: 'مقدار rain هر ورودی',
		},*/
    {
      value: 'time',
      type: 'datetime',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.largeScaleAreaMap.time' />
      ),
    },
  ],
  cloud: [
    {
      value: 'x',
      type: 'string',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.cloud.x' />
      ),
    },
    {
      value: 'value',
      type: 'int',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.cloud.value' />
      ),
    },
  ],
  gage: [
    {
      value: 'value',
      type: 'float',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.gage.value' />
      ),
    },
  ],
  miniBox: [
    {
      value: 'count',
      type: 'float',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.miniBox.count' />
      ),
    },
  ],
  histogram: [
    {
      value: 'name',
      type: 'string',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.histogram.name' />
      ),
    },
    {
      value: 'image',
      type: 'string',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.histogram.image' />
      ),
    },
    {
      value: 'color',
      type: 'string',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.histogram.color' />
      ),
    },
    {
      value: 'vote',
      type: 'int',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.histogram.vote' />
      ),
    },
    {
      value: 'id',
      type: 'string',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.histogram.id' />
      ),
    },
  ],
  miniBoxTimeLine: [
    {
      value: 'src',
      type: 'string',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.miniBoxTimeLine.src' />
      ),
    },
    {
      value: 'name',
      type: 'string',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.miniBoxTimeLine.name' />
      ),
    },
    {
      value: 'email',
      type: 'string',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.miniBoxTimeLine.email' />
      ),
    },
    {
      value: 'date',
      type: 'datetime',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.miniBoxTimeLine.date' />
      ),
    },
    {
      value: 'description',
      type: 'string',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.miniBoxTimeLine.description' />
      ),
    },
  ],
  miniBoxList: [
    {
      value: 'src',
      type: 'string',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.miniBoxList.src' />
      ),
    },
    {
      value: 'name',
      type: 'string',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.miniBoxList.name' />
      ),
    },
    {
      value: 'email',
      type: 'string',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.miniBoxList.email' />
      ),
    },
  ],
  miniBoxHashtag: [
    {
      value: 'word',
      type: 'string',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.miniBoxHashtag.word' />
      ),
    },
    {
      value: 'count',
      type: 'int',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.miniBoxHashtag.count' />
      ),
    },
  ],
  miniBoxLink: [
    {
      value: 'title',
      type: 'string',
    },
    {
      value: 'id',
      type: 'string',
    },
  ],
  miniBoxStats: [
    {
      value: 'word',
      type: 'string',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.miniBoxStats.word' />
      ),
    },
    {
      value: 'count',
      type: 'int',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.miniBoxStats.count' />
      ),
    },
  ],
  miniBoxTag: [
    {
      value: 'hashtag',
      type: 'string',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.miniBoxTag.hashtag' />
      ),
    },
  ],
  donutChart: [
    {
      value: 'count',
      type: 'int',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.donutChart.count' />
      ),
    },
    {
      value: 'item',
      type: 'string',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.donutChart.item' />
      ),
    },
  ],
  kioskBox: [
    {
      value: 'image',
      type: 'string',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.kioskBox.image' />
      ),
    },
    {
      value: 'resource',
      type: 'string',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.kioskBox.resource' />
      ),
    },
  ],
  liveBox: [
    {
      value: 'title',
      type: 'string',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.liveBox.title' />
      ),
    },
    {
      value: 'description',
      type: 'string',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.liveBox.description' />
      ),
    },
  ],
  lineChart: [
    {
      value: 'count',
      type: 'int',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.lineChart.count' />
      ),
    },
    {
      value: 'time',
      type: 'datetime',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.lineChart.time' />
      ),
    },
  ],
  polarChart: [
    {
      value: 'count',
      type: 'int',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.polarChart.count' />
      ),
    },
    {
      value: 'time',
      type: 'datetime',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.polarChart.time' />
      ),
    },
  ],
  wordCluster: [
    {
      value: 'count',
      type: 'int',
      description: (
        <FormattedSimpleMsg id='global_variables.boxGeneratorComponentProps.wordCluster.count' />
      ),
    },
    // {
    // 	value: 'time',
    // 	type: 'datetime',
    // 	description: 'تاریخ و ساعت هر ورودی',
    // }
  ],

  /*areaChart: [
		{
			value: 'count',
			type: 'int',
			description: 'مقدار در هر ورودی',
		} ,
		{
			value: 'time',
			type: 'datetime',
			description: 'تاریخ و ساعت هر ورودی',
		}
	]*/
};

// باکس هایی که نباید فیلتر داشته باشند.
export const boxWithoutFilter = ['liveBox'];

/**
 * Boxes types
 * box
 * miniBox
 * largeScaleAreaMap
 * donutChart
 * cloud
 * gage
 * histogram
 * miniBoxList
 * miniBoxTimeLine
 * miniBoxTag
 * miniBoxHashtag
 * miniBoxStats
 * lineChart
 * waterWave
 * contentBox
 * @type {{"/news/posts": Array, "/news/posts/{id}": Array, "/news/posts/{id}/copies": Array, "/news/agencies": Array, "/news/agencies/{id}": Array, "/news/subjects": Array, "/news/agencies/cloud": Array, "/news/agencies/most_copied": Array, "/news/agencies/most_commented": Array, "/news/agencies/{id}/sources": Array, "/news/agencies/{id}/copies": Array, "/news/info": Array, "/telegram/posts": Array, "/telegram/posts/{id}": Array, "/telegram/channels": Array, "/telegram/channels/{id}": Array, "/telegram/groups/posts": Array, "/telegram/groups": Array, "/telegram/users/{id}/groups": Array, "/telegram/users": Array, "/telegram/groups/{id}/members": Array, "/telegram/subjects": Array, "/telegram/channels/most_viewed": Array, "/telegram/channels/influence": Array, "/telegram/channels/members_history": Array, "/twitter/posts": Array, "/twitter/posts/{id}": Array, "/twitter/posts/mentions": Array, "/twitter/posts/hashtags": Array, "/twitter/users": Array, "/twitter/users/{id}": Array, "/twitter/posts/{id}/retweets": Array, "/twitter/posts/most_mentioned": Array, "/twitter/users/{id}/mentioned": Array, "/twitter/users/{id}/mentions": Array, "/twitter/subjects": Array, "/twitter/subjects/{id}": Array, "/twitter/users/cloud": Array, "/twitter/posts/most_hashtags": Array, "/twitter/users/most_liked": Array, "/twitter/users/most_retweeted": Array, "/twitter/users/influence": Array, "/twitter/users/follow_history": Array, "/twitter/info": Array, "/instagram/posts": Array, "/instagram/posts/{id}": Array, "/instagram/comments": Array, "/instagram/users": Array, "/instagram/users/{id}": Array, "/instagram/comments/cloud": Array, "/instagram/subjects": Array, "/instagram/subjects/{id}": Array, "/instagram/user/{id}/comments/cloud": Array, "/instagram/user/{id}/commented/cloud": Array, "/instagram/users/cloud": Array, "/instagram/users/likes": Array, "/instagram/users/comments": Array, "/instagram/users/{id}/most_comments": Array, "/instagram/users/{id}/most_likes": Array, "/instagram/users/most_liked": Array, "/instagram/users/most_commented": Array, "/instagram/users/influence": Array, "/instagram/users/comments_history": Array, "/instagram/info": Array, "/facebook/posts": Array, "/facebook/users": Array, "/facebook/users/influence": Array}}
 */
export const APIPathsOfPlatform = {
  '/news/posts': {
    boxTypes: [
      'box',
      'miniBox',
      'largeScaleAreaMap',
      'donutChart',
      'cloud',
      'histogram',
      'miniBoxList',
      'miniBoxTimeLine',
      'miniBoxTag',
      'miniBoxHashtag',
      'gage',
      'liveBox',
      'polarChart',
    ],
    resources: ['newsagencies'],
    platform: 'news',
  },
  '/news/posts/deep': {
    boxTypes: [
      'box',
      'miniBox',
      'largeScaleAreaMap',
      'donutChart',
      'cloud',
      'histogram',
      'miniBoxList',
      'miniBoxTimeLine',
      'miniBoxTag',
      'miniBoxHashtag',
      'polarChart',
    ],
    resources: ['newsagencies'],
    platform: 'news',
  },
  '/news/posts/{id}': {
    boxTypes: [],
    resources: [],
    platform: 'news',
  },
  '/news/posts/{id}/copies': {
    boxTypes: [],
    resources: [],
    platform: 'news',
  },
  '/news/subjects': {
    boxTypes: ['cloud', 'miniBoxHashtag'],
    resources: ['newsagencies'],
    platform: 'news',
  },
  '/news/subjects/{id}': {
    boxTypes: [],
    resources: [],
    platform: 'news',
  },
  '/news/posts/publish_process': {
    boxTypes: [
      'largeScaleAreaMap',
      'miniBoxHashtag',
      'lineChart',
      'polarChart',
    ],
    resources: ['newsagencies'],
    platform: 'news',
  },
  '/news/agencies': {
    boxTypes: [
      'box',
      'miniBox',
      'largeScaleAreaMap',
      'donutChart',
      'cloud',
      'histogram',
      'miniBoxList',
      'miniBoxTimeLine',
      'miniBoxTag',
      'miniBoxHashtag',
    ],
    resources: ['newsagencies'],
    platform: 'newsagencies',
  },
  '/news/agencies/{id}': {
    boxTypes: [],
    resources: [],
    platform: 'newsagencies',
  },
  '/news/agencies/most_copied': {
    boxTypes: [],
    resources: ['newsagencies'],
    platform: 'newsagencies', //----
  },
  '/news/agencies/most_commented': {
    boxTypes: [],
    resources: ['newsagencies'],
    platform: 'newsagencies', //----
  },
  '/news/agencies/{id}/sources': {
    boxTypes: [],
    resources: [],
    platform: 'newsagencies',
  },
  '/news/agencies/{id}/copies': {
    boxTypes: [],
    resources: [],
    platform: 'newsagencies',
  },
  '/news/agencies/cloud': {
    boxTypes: ['cloud', 'miniBoxHashtag'],
    resources: ['newsagencies'],
    platform: 'newsagencies', //----
  },
  '/news/info': {
    boxTypes: ['gage', 'miniBox', 'miniBoxStats', 'donutChart'],
    resources: [],
    platform: 'news',
  },
  '/news/info/process': {
    boxTypes: [
      //"largeScaleAreaMap", "miniBoxHashtag", "areaMap"
    ],
    resources: ['newsagencies'],
    platform: 'news',
  },

  '/telegram/posts': {
    boxTypes: [
      'box',
      'miniBox',
      'largeScaleAreaMap',
      'donutChart',
      'cloud',
      'histogram',
      'miniBoxList',
      'miniBoxTimeLine',
      'miniBoxTag',
      'miniBoxHashtag',
      'liveBox',
      'polarChart',
    ],
    resources: ['telegramchannels'],
    platform: 'telegram',
  },
  '/telegram/posts/deep': {
    boxTypes: [
      'box',
      'miniBox',
      'largeScaleAreaMap',
      'donutChart',
      'cloud',
      'histogram',
      'miniBoxList',
      'miniBoxTimeLine',
      'miniBoxTag',
      'miniBoxHashtag',
      'polarChart',
    ],
    resources: ['telegramchannels'],
    platform: 'telegram',
  },
  '/telegram/posts/{id}': {
    boxTypes: [],
    resources: [],
    platform: 'telegram',
  },
  '/telegram/posts/{id}/duplicates': {
    boxTypes: [],
    resources: [],
    platform: 'telegram',
  },
  '/telegram/posts/similarity': {
    boxTypes: [],
    resources: [],
    platform: 'telegram',
  },
  '/telegram/posts/clustercloud': {
    boxTypes: ['wordCluster'],
    resources: [],
    platform: 'telegram',
  },
  '/telegram/subjects': {
    boxTypes: ['cloud', 'miniBoxHashtag'],
    resources: ['telegramchannels'],
    platform: 'telegram',
  },
  '/telegram/subjects/{total_post_id}': {
    boxTypes: [],
    resources: [],
    platform: 'telegram',
  },
  '/telegram/posts/post_process': {
    boxTypes: [
      'largeScaleAreaMap',
      'miniBoxHashtag',
      'lineChart',
      'polarChart',
    ],
    resources: ['telegramchannels'],
    platform: 'telegram',
  },
  '/telegram/channels': {
    boxTypes: [
      'box',
      'miniBox',
      'largeScaleAreaMap',
      'donutChart',
      'cloud',
      'histogram',
      'miniBoxList',
      'miniBoxTimeLine',
      'miniBoxTag',
      'miniBoxHashtag',
      'polarChart',
    ],
    resources: ['telegramchannels'],
    platform: 'telegramchannels',
  },
  '/telegram/comments': {
    boxTypes: [
      'box',
      'miniBox',
      'largeScaleAreaMap',
      'donutChart',
      'cloud',
      'histogram',
      'miniBoxList',
      'miniBoxTimeLine',
      'miniBoxTag',
      'miniBoxHashtag',
      'polarChart',
    ],
    resources: ['telegramusers'],
    platform: 'telegramcomments',
  },
  '/telegram/channels/{id}': {
    boxTypes: [],
    resources: [],
    platform: 'telegramchannels',
  },
  '/telegram/channels/views': {
    boxTypes: ['cloud', 'miniBoxHashtag', 'gage'],
    resources: ['telegramchannels'],
    platform: 'telegramchannels',
  },
  '/telegram/channels/most_viewed': {
    boxTypes: [],
    resources: ['telegramchannels'],
    platform: 'telegramchannels', //---
  },
  '/telegram/channels/cloud': {
    boxTypes: ['cloud', 'miniBoxHashtag'],
    resources: ['telegramchannels'],
    platform: 'telegramchannels',
  },
  '/telegram/channels/influence': {
    boxTypes: [
      //"largeScaleAreaMap" , "miniBoxHashtag" TODO need to ids
    ],
    resources: ['telegramchannels'],
    platform: 'telegramchannels', //---
  },
  '/telegram/channels/members_history': {
    boxTypes: [
      //"largeScaleAreaMap" , "miniBoxHashtag" , "gage" TODO need to ids
    ],
    resources: ['telegramchannels'],
    platform: 'telegramchannels',
  },
  '/telegram/groups/posts': {
    boxTypes: [
      'box',
      'miniBox',
      'largeScaleAreaMap',
      'donutChart',
      'cloud',
      'histogram',
      'miniBoxList',
      'miniBoxTimeLine',
      'miniBoxTag',
      'miniBoxHashtag',
      'polarChart',
    ],
    resources: ['telegramgroups', 'telegramusers'],
    platform: 'telegramgroupsposts',
  },
  '/telegram/groups/posts/deep': {
    boxTypes: [
      'box',
      'miniBox',
      'largeScaleAreaMap',
      'donutChart',
      'cloud',
      'histogram',
      'miniBoxList',
      'miniBoxTimeLine',
      'miniBoxTag',
      'miniBoxHashtag',
      'polarChart',
    ],
    resources: ['telegramgroups', 'telegramusers'],
    platform: 'telegramgroupsposts',
  },
  '/telegram/groups': {
    boxTypes: [
      'box',
      'miniBox',
      'largeScaleAreaMap',
      'donutChart',
      'cloud',
      'histogram',
      'miniBoxList',
      'miniBoxTimeLine',
      'miniBoxTag',
      'miniBoxHashtag',
    ],
    resources: ['telegramgroups'],
    platform: 'telegramgroups',
  },
  '/telegram/users/{id}/groups': {
    boxTypes: [],
    resources: [],
    platform: 'telegramgroups',
  },
  '/telegram/groups/{id}/members': {
    boxTypes: [],
    resources: [],
    platform: 'telegramusers',
  },
  '/telegram/media/{id}': {
    boxTypes: [],
    resources: [],
    platform: 'telegram',
  },
  '/telegram/info': {
    boxTypes: ['gage', 'miniBox', 'miniBoxStats', 'donutChart'],
    resources: ['telegramchannels'],
    platform: 'telegram',
  },
  '/telegram/info/process': {
    boxTypes: [
      //"largeScaleAreaMap", "miniBoxHashtag", "areaMap"
    ],
    resources: ['telegramchannels'],
    platform: 'telegram',
  },
  '/telegram/users': {
    boxTypes: [
      'box',
      'miniBox',
      'largeScaleAreaMap',
      'donutChart',
      'cloud',
      'histogram',
      'miniBoxList',
      'miniBoxTimeLine',
      'miniBoxTag',
      'miniBoxHashtag',
      'polarChart',
    ],
    resources: ['telegramusers'],
    platform: 'telegramusers',
  },
  '/telegram/users/deep': {
    boxTypes: [
      'box',
      'miniBox',
      'largeScaleAreaMap',
      'donutChart',
      'cloud',
      'histogram',
      'miniBoxList',
      'miniBoxTimeLine',
      'miniBoxTag',
      'miniBoxHashtag',
      'polarChart',
    ],
    resources: ['telegramusers'],
    platform: 'telegramusers',
  },
  '/telegram/users/{id}/most_replied': {
    boxTypes: [],
    resources: [],
    platform: 'telegramusers',
  },
  '/telegram/posts/{channel_id_post_id}/release': {
    boxTypes: [],
    resources: [],
    platform: '',
  },
  '/telegram/channels/count_by_members': {
    boxTypes: ['donutChart'],
    resources: [],
    platform: 'telegramchannels',
  },
  '/twitter/posts': {
    boxTypes: [
      'box',
      'miniBox',
      'largeScaleAreaMap',
      'donutChart',
      'cloud',
      'histogram',
      'miniBoxList',
      'miniBoxTimeLine',
      'miniBoxTag',
      'miniBoxHashtag',
      'gage',
      'liveBox',
      'polarChart',
    ],
    resources: ['twitterusers'],
    platform: 'twitter',
  },
  '/twitter/posts/deep': {
    boxTypes: [
      'box',
      'miniBox',
      'largeScaleAreaMap',
      'donutChart',
      'cloud',
      'histogram',
      'miniBoxList',
      'miniBoxTimeLine',
      'miniBoxTag',
      'miniBoxHashtag',
      'polarChart',
    ],
    resources: ['twitterusers'],
    platform: 'twitter',
  },
  '/twitter/posts/{id}': {
    boxTypes: [],
    resources: [],
    platform: 'twitter',
  },
  '/twitter/posts/{id}/duplicates': {
    boxTypes: [],
    resources: [],
    platform: 'twitter',
  },
  '/twitter/posts/similarity': {
    boxTypes: [],
    resources: [],
    platform: 'twitter',
  },
  '/twitter/posts/mentions': {
    boxTypes: ['miniBoxHashtag'],
    resources: ['twitterusers'],
    platform: 'twitter',
  },
  '/twitter/posts/most_mentioned': {
    boxTypes: ['miniBoxHashtag'],
    resources: ['twitterusers'],
    platform: 'twitter',
  },
  '/twitter/posts/hashtags': {
    boxTypes: ['largeScaleAreaMap', 'miniBoxHashtag', 'polarChart'],
    resources: ['twitterusers'],
    platform: 'twitter',
  },
  '/twitter/posts/most_hashtags': {
    boxTypes: ['cloud', 'miniBoxHashtag'],
    resources: ['twitterusers'],
    platform: 'twitter',
  },
  '/twitter/posts/tweet_process': {
    boxTypes: [
      'largeScaleAreaMap',
      'miniBoxHashtag',
      'lineChart',
      'polarChart',
    ],
    resources: ['twitterusers'],
    platform: 'twitter',
  },
  '/twitter/subjects': {
    boxTypes: ['cloud', 'miniBoxHashtag'],
    resources: ['twitterusers'],
    platform: 'twitter',
  },
  '/twitter/subjects/{id}': {
    boxTypes: [],
    resources: [],
    platform: 'twitter',
  },
  '/twitter/users': {
    boxTypes: [
      'box',
      'miniBox',
      'largeScaleAreaMap',
      'donutChart',
      'cloud',
      'histogram',
      'miniBoxList',
      'miniBoxTimeLine',
      'miniBoxTag',
      'miniBoxHashtag',
      'polarChart',
    ],
    resources: ['twitterusers'],
    platform: 'twitterusers',
  },
  '/twitter/users/{id}': {
    boxTypes: [],
    resources: [],
    platform: 'twitterusers',
  },
  '/twitter/users/likes': {
    boxTypes: ['cloud', 'miniBoxHashtag', 'gage'],
    resources: ['twitterusers'],
    platform: 'twitterusers', //---
  },
  '/twitter/users/most_liked': {
    boxTypes: [],
    resources: ['twitterusers'],
    platform: 'twitterusers', //---
  },
  '/twitter/users/most_retweeted': {
    boxTypes: [],
    resources: ['twitterusers'],
    platform: 'twitterusers', //---
  },
  '/twitter/users/cloud': {
    boxTypes: ['cloud', 'miniBoxHashtag'],
    resources: ['twitterusers'],
    platform: 'twitterusers', //---
  },
  '/twitter/users/influence': {
    boxTypes: [
      //"largeScaleAreaMap" , "miniBoxHashtag" TODO need to ids
    ],
    resources: ['twitterusers'],
    platform: 'twitterusers', //---
  },
  '/twitter/users/retweets_history': {
    boxTypes: [],
    resources: ['twitterusers'],
    platform: 'twitterusers', //---
  },
  '/twitter/users/follow_history': {
    boxTypes: [
      'largeScaleAreaMap',
      'miniBoxHashtag',
      'polarChart', //---
    ],
    resources: ['twitterusers'],
    platform: 'twitterusers',
  },
  '/twitter/users/history': {
    boxTypes: [
      'largeScaleAreaMap',
      'miniBoxHashtag',
      'histogram',
      'cloud',
      'polarChart',
    ],
    resources: ['twitterusers'],
    platform: 'twitterusers', //---
  },
  '/twitter/users/{id}/mentioned': {
    boxTypes: [],
    resources: [],
    platform: 'twitterusers',
  },
  '/twitter/users/{id}/mentions': {
    boxTypes: [],
    resources: [],
    platform: 'twitterusers',
  },
  '/twitter/media/{id}': {
    boxTypes: [],
    resources: [],
    platform: 'twitter',
  },
  '/twitter/info': {
    boxTypes: ['gage', 'miniBox', 'miniBoxStats', 'donutChart'],
    resources: ['twitterusers'],
    platform: 'twitter',
  },
  '/twitter/info/process': {
    boxTypes: [
      //"largeScaleAreaMap", "miniBoxHashtag", "areaMap"
    ],
    resources: ['twitterusers'],
    platform: 'twitter',
  },
  '/twitter/posts/{id}/retweets': {
    boxTypes: [],
    resources: [],
    platform: 'twitter',
  },
  '/twitter/users/count_by_followers': {
    boxTypes: ['donutChart'],
    resources: [],
    platform: 'twitterusers',
  },
  '/twitter/live/search': {
    boxTypes: [],
    resources: [],
    platform: 'twitter',
  },
  '/twitter/live/home/{id}': {
    boxTypes: [],
    resources: [],
    platform: 'twitter',
  },
  '/twitter/live/retweets_of_me/{id}': {
    boxTypes: [],
    resources: [],
    platform: 'twitter',
  },
  '/twitter/live/mentions/{id}': {
    boxTypes: [],
    resources: [],
    platform: 'twitter',
  },
  '/twitter/live/my_posts/{id}': {
    boxTypes: [],
    resources: [],
    platform: 'twitter',
  },
  '/instagram/posts': {
    boxTypes: [
      'box',
      'miniBox',
      'largeScaleAreaMap',
      'donutChart',
      'cloud',
      'histogram',
      'miniBoxList',
      'miniBoxTimeLine',
      'miniBoxTag',
      'miniBoxHashtag',
      'liveBox',
      'polarChart',
    ],
    resources: ['instagramusers'],
    platform: 'instagram',
  },
  '/instagram/posts/deep': {
    boxTypes: [
      'box',
      'miniBox',
      'largeScaleAreaMap',
      'donutChart',
      'cloud',
      'histogram',
      'miniBoxList',
      'miniBoxTimeLine',
      'miniBoxTag',
      'miniBoxHashtag',
      'polarChart',
    ],
    resources: ['instagramusers'],
    platform: 'instagram',
  },
  '/instagram/posts/{id}': {
    boxTypes: [],
    resources: [],
    platform: 'instagram',
  },
  '/instagram/posts/{id}/duplicates': {
    boxTypes: [],
    resources: [],
    platform: 'instagram',
  },
  '/instagram/posts/similarity': {
    boxTypes: [],
    resources: [],
    platform: 'instagram',
  },
  '/instagram/comments': {
    boxTypes: [
      'box',
      'miniBox',
      'largeScaleAreaMap',
      'donutChart',
      'cloud',
      'histogram',
      'miniBoxList',
      'miniBoxTimeLine',
      'miniBoxTag',
      'miniBoxHashtag',
      'polarChart',
    ],
    resources: ['instagramusers'],
    platform: 'instagramcomments',
  },
  '/instagram/comments/cloud': {
    boxTypes: ['cloud', 'miniBoxHashtag'],
    resources: ['instagramusers'],
    platform: 'instagramcomments',
  },
  '/instagram/subjects': {
    boxTypes: ['cloud', 'miniBoxHashtag'],
    resources: ['instagramusers'],
    platform: 'instagram',
  },
  '/instagram/subjects/{id}': {
    boxTypes: [],
    resources: [],
    platform: 'instagram',
  },
  '/instagram/posts/share_process': {
    boxTypes: [
      'largeScaleAreaMap',
      'miniBoxHashtag',
      'lineChart',
      'polarChart',
    ],
    resources: ['instagramusers'],
    platform: 'instagram',
  },
  '/instagram/users': {
    boxTypes: [
      'box',
      'miniBox',
      'largeScaleAreaMap',
      'donutChart',
      'cloud',
      'histogram',
      'miniBoxList',
      'miniBoxTimeLine',
      'miniBoxTag',
      'miniBoxHashtag',
      'polarChart',
    ],
    resources: ['instagramusers'], //---,
    platform: 'instagramusers',
  },
  '/instagram/users/{id}': {
    boxTypes: [],
    resources: [],
    platform: 'instagramusers',
  },
  '/instagram/user/{id}/comments/cloud': {
    boxTypes: [],
    resources: [],
    platform: 'instagramusers',
  },
  '/instagram/user/{id}/commented/cloud': {
    boxTypes: [],
    resources: [],
    platform: 'instagramusers',
  },
  '/instagram/users/likes': {
    boxTypes: ['miniBoxHashtag'],
    resources: ['instagramusers'],
    platform: 'instagramusers', //---
  },
  '/instagram/users/comments': {
    boxTypes: ['miniBoxHashtag'],
    resources: ['instagramusers'],
    platform: 'instagram', //---
  },
  '/instagram/users/most_liked': {
    boxTypes: [],
    resources: ['instagramusers'],
    platform: 'instagramusers', //---
  },
  '/instagram/users/most_commented': {
    boxTypes: [],
    resources: ['instagramusers'],
    platform: 'instagramusers', //---
  },
  '/instagram/users/{id}/most_comments': {
    boxTypes: [],
    resources: [],
    platform: 'instagramusers',
  },
  '/instagram/users/{id}/most_likes': {
    boxTypes: [],
    resources: [],
    platform: 'instagramusers',
  },
  '/instagram/users/cloud': {
    boxTypes: ['cloud', 'miniBoxHashtag'],
    resources: ['instagramusers'],
    platform: 'instagramusers', //---
  },
  '/instagram/users/influence': {
    boxTypes: [
      //"largeScaleAreaMap" , "miniBoxHashtag" TODO need to ids
    ],
    resources: ['instagramusers'],
    platform: 'instagramusers', //---
  },
  '/instagram/users/comments_history': {
    boxTypes: ['largeScaleAreaMap', 'miniBoxHashtag', 'polarChart'],
    resources: ['instagramusers'],
    platform: 'instagramusers', //----
  },
  '/instagram/users/follow_history': {
    boxTypes: ['largeScaleAreaMap', 'miniBoxHashtag', 'polarChart'],
    resources: ['instagramusers'],
    platform: 'instagramusers', //---
  },
  '/instagram/info': {
    boxTypes: ['gage', 'miniBox', 'miniBoxStats', 'donutChart'],
    resources: [],
    platform: 'instagram',
  },
  '/instagram/info/process': {
    boxTypes: [
      //"largeScaleAreaMap", "miniBoxHashtag", "areaMap"
    ],
    resources: ['instagramusers'],
    platform: 'instagram',
  },
  '/instagram/batch/publish/process': {
    boxTypes: [
      'largeScaleAreaMap',
      'miniBoxHashtag',
      'areaMap',
      'lineChart',
      'polarChart',
    ],
    resources: ['instagramusers'],
    platform: 'instagram',
  },
  '/instagram/users/count_by_followers': {
    boxTypes: ['donutChart'],
    resources: [],
    platform: 'instagramusers',
  },
  '/instagram/live/my_posts/{id}': {
    boxTypes: [],
    resources: [],
    platform: 'instagram',
  },
  '/search_engine/feeds': {
    boxTypes: [
      'box',
      'miniBox',
      'donutChart',
      'miniBoxList',
      'miniBoxTimeLine',
      'miniBoxTag',
      'miniBoxHashtag',
    ],
    resources: [],
    platform: '', // not in api
  },
  '/search_engine/posts': {
    boxTypes: [
      'box',
      'miniBox',
      'largeScaleAreaMap',
      'donutChart',
      'cloud',
      'histogram',
      'miniBoxList',
      'miniBoxTimeLine',
      'miniBoxTag',
      'miniBoxHashtag',
      'polarChart',
    ],
    resources: [],
    platform: 'search_engine',
  },
  '/rrk/posts': {
    boxTypes: [
      'box',
      'miniBox',
      'largeScaleAreaMap',
      'donutChart',
      'cloud',
      'histogram',
      'miniBoxList',
      'miniBoxTimeLine',
      'miniBoxTag',
      'miniBoxHashtag',
      'polarChart',
    ],
    resources: [],
    platform: 'rrk',
  },
  '/whois/fields': {
    boxTypes: [
      'box',
      'miniBox',
      'histogram',
      'miniBoxList',
      'miniBoxTimeLine',
      'miniBoxTag',
      'miniBoxHashtag',
    ],
    resources: [],
    platform: '', // not in api
  },
  '/facebook/posts': {
    boxTypes: [
      'box',
      'miniBox',
      'largeScaleAreaMap',
      'donutChart',
      'cloud',
      'histogram',
      'miniBoxList',
      'miniBoxTimeLine',
      'miniBoxTag',
      'miniBoxHashtag',
      'liveBox',
      'polarChart',
    ],
    resources: ['facebookusers'],
    platform: 'facebook',
  },
  '/facebook/posts/deep': {
    boxTypes: [
      'box',
      'miniBox',
      'largeScaleAreaMap',
      'donutChart',
      'cloud',
      'histogram',
      'miniBoxList',
      'miniBoxTimeLine',
      'miniBoxTag',
      'miniBoxHashtag',
      'polarChart',
    ],
    resources: ['facebookusers'],
    platform: 'facebook',
  },
  '/facebook/pages': {
    boxTypes: [
      'box',
      'miniBox',
      'largeScaleAreaMap',
      'donutChart',
      'cloud',
      'histogram',
      'miniBoxList',
      'miniBoxTimeLine',
      'miniBoxTag',
      'miniBoxHashtag',
      'polarChart',
    ],
    // resources: ["facebookpages", "facebookusers"],
    resources: ['facebookusers'],
    platform: 'facebookpages',
  },
  '/facebook/users': {
    boxTypes: [
      'box',
      'miniBox',
      'largeScaleAreaMap',
      'donutChart',
      'cloud',
      'histogram',
      'miniBoxList',
      'miniBoxTimeLine',
      'miniBoxTag',
      'miniBoxHashtag',
      'polarChart',
    ],
    resources: ['facebookusers'],
    platform: 'facebookusers',
  },
  '/facebook/users/influence': {
    boxTypes: [
      //"largeScaleAreaMap" , "miniBoxHashtag" TODO need to user_ids
    ],
    resources: ['facebookusers'],
    platform: 'facebookusers',
  },
  '/ketabavval/posts': {
    boxTypes: [
      'box',
      'miniBox',
      'largeScaleAreaMap',
      'donutChart',
      'cloud',
      'histogram',
      'miniBoxList',
      'miniBoxTimeLine',
      'miniBoxTag',
      'miniBoxHashtag',
      'polarChart',
    ],
    resources: [],
    platform: 'ketabavval',
  },
  '/dumper/feeds': {
    boxTypes: [
      'miniBox',
      'donutChart',
      'miniBoxList',
      'miniBoxTimeLine',
      'miniBoxTag',
      'miniBoxHashtag',
    ],
    resources: [],
    platform: '', // not in api response
  },
  '/dumper/posts': {
    boxTypes: [
      'box',
      'miniBox',
      'largeScaleAreaMap',
      'donutChart',
      'cloud',
      'histogram',
      'miniBoxList',
      'miniBoxTimeLine',
      'miniBoxTag',
      'miniBoxHashtag',
      'lineChart',
    ],
    resources: [],
    platform: 'dumper',
  },
  '/blog/posts': {
    boxTypes: [
      'box',
      'miniBox',
      'largeScaleAreaMap',
      'donutChart',
      'cloud',
      'histogram',
      'miniBoxList',
      'miniBoxTimeLine',
      'miniBoxTag',
      'miniBoxHashtag',
      'lineChart',
    ],
    resources: [],
    platform: 'blog',
  },
  '/advertisement/posts': {
    boxTypes: [
      'box',
      'miniBox',
      'largeScaleAreaMap',
      'donutChart',
      'cloud',
      'histogram',
      'miniBoxList',
      'miniBoxTimeLine',
      'miniBoxTag',
      'miniBoxHashtag',
      'lineChart',
    ],
    resources: [],
    platform: 'advertisement',
  },
  '/dunro/posts': {
    boxTypes: [
      'box',
      'miniBox',
      'largeScaleAreaMap',
      'donutChart',
      'cloud',
      'histogram',
      'miniBoxList',
      'miniBoxTimeLine',
      'miniBoxTag',
      'miniBoxHashtag',
      'lineChart',
    ],
    resources: [],
    platform: 'dunro',
  },
  '/wikileaks/posts': {
    boxTypes: [
      'box',
      'miniBox',
      'largeScaleAreaMap',
      'donutChart',
      'cloud',
      'histogram',
      'miniBoxList',
      'miniBoxTimeLine',
      'miniBoxTag',
      'miniBoxHashtag',
      'lineChart',
    ],
    resources: [],
    platform: 'wikileaks',
  },
  '/graph': {
    boxTypes: [],
    resources: [],
    platform: '', // not in api response
  },
  '/graph/relation': {
    boxTypes: [],
    resources: [],
    platform: '', // not in api response
  },
  '/newspaper/posts': {
    boxTypes: ['kioskBox'],
    resources: ['newspaperagencies'],
    platform: 'newspaper',
  },
  '/newspaper/agencies': {
    boxTypes: [],
    resources: ['newspaperagencies'],
    platform: 'newspaper',
  },
  '/twitter/live/my_favorites/{id}': {
    boxTypes: [],
    resources: [],
    platform: 'twitter',
  },
  '/conversation': {
    boxTypes: [],
    resources: ['twitterusers'],
    platform: 'twitter',
  },
};

/**
 * پریست پیشفرض
 */
export const handMadePreset = {
  preset_title: 'پیش‌فرض‌ 1',
  general_params: {
    telegramposts: true,
    instagramposts: true,
    twitterposts: true,
  },
  platforms: [
    {
      api_path: '/telegram/posts',
      name: 'telegramposts',
    },
    {
      api_path: '/instagram/posts',
      name: 'instagramposts',
    },
    {
      api_path: '/twitter/posts',
      name: 'twitterposts',
    },
  ],
};

/**
 * مقدار پیش‌فرض‌ برای انتخاب منابع
 */
export const resourcePlatforms = [
  'newspaperagencies',
  'newsagencies',
  'instagramusers',
  'twitterusers',
  'telegramusers',
  'telegramchannels',
  'telegramgroups',
  'facebookusers',
  'facebookpages',
];

/**
 * مقدار پیش‌فرض‌ برای موجودیت ها
 */
export const existsList = [
  'extracted_ip',
  'extracted_url',
  'extracted_email',
  'extracted_phone',
  'extracted_mobile',
  'extracted_hashtag',
  'extracted_mention',
  'extracted_postal_code',
  'extracted_national_code',
];

/**
 * مقدار پیش‌فرض‌ برای شاخص آنالیز
 */
export const analyzerList = [
  'group',
  'subject',
  'subject2',
  'person',
  'viewpoint',
  'tone',
  'technique',
  'template_content',
];

/**
 * پلتفرم های مجاز برای ارسال به بولتن
 */
export const validBulletinPlatforms = [
  'news',
  'newsposts',
  'instagram',
  'instagramposts',
  'twitter',
  'twitterposts',
  // "telegramchannels",
  // "telegramgroups",
  // "telegramgroupsposts",
  'telegramposts',
  'telegram',
  'facebook',
  // "advertisement",
  // "blog",
  // "dumper",
  // "dunro",
  // "ketabavval",
  // "rrk",
  // "search_engine",
  // "wikileak",
];

export const notPostSearchList = [
  '/telegram/channels',
  '/telegram/users',
  '/telegram/groups',
  '/facebook/users',
  '/facebook/pages',
  // '/instagram/posts', // ?????????
  // '/instagram/comments', // ?????????
  '/instagram/users',
  '/twitter/users',
];

// پلتفرم های شبکه اجتماعی و
export const newsAndSocials = [
  '/facebook/posts',
  '/instagram/posts',
  '/news/posts',
  '/telegram/posts',
  '/twitter/posts',
  '/wikileaks/posts',
];

// مپ کردن اسم پلتفرم ها به منابع
export const getResourcePlatforms = {
  newspaper: ['newspaperagencies'],
  news: ['newsagencies'],
  instagram: ['instagramusers'],
  twitter: ['twitterusers'],
  //"telegram": ["telegramusers"],
  telegram: ['telegramchannels'],
  //"telegramgroups": 	"telegramgroups",
  facebook: ['facebookusers'],
  //"facebookpages": 	"facebookpages"
};

export const planningFilterFields = [
  'samane_post_status',
  'samane_is_deleted',
  'samane_delete_by_user_ids',
  'samane_is_assigned',
  'samane_is_replied',
  'samane_assign_user_ids',
  'samane_assigner_user_ids',
  'samane_favourite_user_ids',
  'samane_seen_user_ids',
  'account_ids',
  'has_content_tag',
  'has_location',
  'prob_categories',
  'seen',
];

export const categorySubCategory = {
  Varzeshi: [
    'KoshtiVaVazneBardari',
    'SaiereHozeha',
    'FootballIran',
    'FootballJahan',
    'Razmi',
    'ToopVaTour',
  ],
  Siasi: [
    'EmamVaRahbari',
    'AhzabVaTashakolha',
    'AmniatiVaDefaee',
    'Dolat',
    'Majles',
    'TashakolhaieDaneshghai',
  ],
  Eghtesadi: [
    'EghtesadKalanVaBoodje',
    'TaavonVaEshteghal',
    'Boors',
    'BimeVaBank',
    'RahVaMaskan',
    'SanatTejaratBazargani',
    'KeshavarziVaOmooreDam',
    'NaftVaEnergy',
    'EghtesadeBinolmelal',
  ],
  ElmiVaDaneshghai: ['Amouzesh', 'ElamVaFanavariIran', 'ElamVaFanavariJahan'],
  Farhang: [
    'KetabVaAdabiat',
    'Andishe',
    'QuranVaFaaliathaieDini',
    'MasjedVaHeiat',
    'HajVaZiaratVaVaghf',
  ],
  Ejtemaee: [
    'Salamat',
    'AmouzeshVaParvaresh',
    'HoghoughiVaGhazaee',
    'EntezamiVaHavades',
    'MohitZistVaGardeshgari',
    'Shahri',
    'ZananVaJavanan',
  ],
  HonarVaResane: [
    'RadioVaTV',
    'CinemaVaTheatre',
    'MousighiVaHonarhaieTajasomi',
  ],
  Beinolmelal: [
    'AmricaVaEurope',
    'SharghAsiaVaOghianousie',
    'GharbAsia',
    'Africa',
  ],
  FarhangHonarVaResane: [
    'DiniVaMazhabi',
    'RadioVaTV',
    'CinemaVaTheatre',
    'MousighiVaHonarhaieTajasomi',
    'RefahVaAsibhaieEjtemaee',
  ],
  Roozmare: ['Roozmare'],
};
export const statusLogDirect = {
  assign: {
    label: 'اساین شده به ',
    icon: 'icon icon-assign',
  },
  assign_conversation: {
    label: 'اساین شده به ',
    icon: 'icon icon-assign',
  },
  closed: {
    label: 'انجام شده توسط ',
    icon: 'icon icon-done',
  },
  replied: {
    label: 'پاسخ داده شده توسط ',
    icon: 'icon icon-replyed',
  },
  new_server_direct: {
    label: 'پیام خوانده نشده',
    icon: '',
  },
  pending: {
    label: 'تغییر وضعیت به در انتظار  توسط    ',
    icon: 'icon icon-pending',
  },
  no_need: {
    label: 'تغییر وضعیت به نیازی نیست  توسط    ',
    icon: 'icon icon-eye',
  },
};

export const statusListDirect = [
  {
    label: 'انجام شده',
    value: 'closed',
    icon: 'icon icon-done',
  },
  {
    label: 'نیازی نیست',
    value: 'no_need',
    icon: 'icon icon-eye',
  },
  {
    label: 'پاسخ داده شده',
    value: 'replied',
    icon: 'icon icon-replyed',
  },
  {
    label: 'در انتظار',
    value: 'pending',
    icon: 'icon icon-pending',
  },
];

export const statusBoxTypeListDirect = [
  { title: 'اساین نشده', type: 'notAssigned', status: null },
  { title: 'اساین شده', type: 'assigned', status: null },
  { title: 'اساین به من', type: 'mine', status: null },
  { title: 'انجام شده ', type: 'resolved', status: null },
  { title: 'نیازی نیست ', type: 'mine', status: 'no_need' },
  { title: ' در انتظار پاسخ', type: 'mine', status: 'pending' },
  { title: ' پاسخ داده شده ', type: 'mine', status: 'replied' },
];

export const statusListAssignment = [
  {
    label: 'فیلتر ندارد',
    value: null,
    icon: 'icon icon-all',
  },
  {
    label: 'بدون وضعیت',
    value: 'not_specified',
    icon: 'icon icon-status',
  },
  {
    label: 'نیازی نیست',
    value: 'no_need',
    icon: 'icon icon-eye',
  },
  {
    label: 'پاسخ داده شده',
    value: 'replied',
    icon: 'icon icon-replyed',
  },
  {
    label: 'در انتظار',
    value: 'pending',
    icon: 'icon icon-pending',
  },
  {
    label: 'حذف شده',
    value: 'deleted',
    icon: 'icon icon-delete',
  },
];

export const topicModelingPlatformMap = {
  '/telegram/posts': {
    icon: 'icon-telegram',
    color: '#32AADD',
    title: 'تلگرام',
    name: 'telegram',
    plain: 'telegramposts',
  },
  '/twitter/posts': {
    icon: 'icon-twitter',
    color: '#5AD1F6',
    title: 'توییتر',
    name: 'twitter',
    plain: 'twitterposts',
  },
  '/instagram/posts': {
    icon: 'icon-instagram',
    color: '#C63C73',
    title: 'اینستاگرام',
    name: 'instagram',
    plain: 'instagramposts',
  },
  '/news/posts': {
    icon: 'icon-newspaper',
    color: '#199DA3',
    title: 'خبر',
    name: 'news',
    plain: 'newsposts',
  },
};
